@if (show$ | async) {
  <mat-progress-bar
    [mode]="mode$ | async"
  [value]="progress$ | async"></mat-progress-bar>
}
